/* Corrección para SeedGrow click-to-chat.
   El mensaje completo se codifica una sola vez y usa la URL vigente al pulsar. */
(function (root) {
  'use strict';
  function buildWhatsAppLink(href, template, title, pageUrl) {
    const url = new URL(href);
    const allowed = ['api.whatsapp.com', 'web.whatsapp.com', 'wa.me'];
    if (!allowed.includes(url.hostname) && url.protocol !== 'whatsapp:') return href;
    const phone = url.searchParams.get('phone');
    const message = template
      .replace(/\[(?:njwa|sgwa)_page_title\]/gi, () => title)
      .replace(/\[(?:njwa|sgwa)_page_url\]/gi, () => pageUrl);
    url.search = '';
    url.hash = '';
    if (phone) url.searchParams.set('phone', phone);
    url.searchParams.set('text', message);
    return url.toString();
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { buildWhatsAppLink };
  if (!root.document) return;
  root.lordBuildWhatsAppLink = buildWhatsAppLink;
  function update(event) {
    const anchor = event.target.closest && event.target.closest('#wa__widget_simple');
    if (!anchor) return;
    const config = root.seedgrow_wa_data || root.seedgrowWhatsAppData;
    if (!config || !Array.isArray(config.accounts)) return;
    const digits = value => String(value || '').replace(/\D/g, '');
    const account = config.accounts.find(a => digits(a.number) === digits(anchor.getAttribute('data-wa-number')));
    if (!account || !account.predefinedText) return;
    anchor.href = buildWhatsAppLink(anchor.href, account.predefinedText, root.document.title, root.location.href);
  }
  // Funciona también si el widget se crea después del script. No envía ningún mensaje.
  for (const event of ['pointerdown', 'click', 'auxclick', 'contextmenu', 'focusin']) {
    root.document.addEventListener(event, update, true);
  }
})(typeof window !== 'undefined' ? window : globalThis);
